<template>
  <Container :bounds-inner-styles="containerStyles">
    <h2 class="scout-keypoints-title">
      Traditional headhunting sucks, so we reinvented it — for
      <b style="color:#4440db">startups</b> this time
    </h2>
    <b-row class="scout-keypoints-points">
      <div v-for="point in points" :key="point.id" class="scout-keypoints-point_wrapper">
        <img class="scout-keypoints-point_logo" :src="point.img" />
        <div class="scout-keypoints-point_title">{{ point.title }}</div>
        <div class="scout-keypoints-point_description">{{ point.description }}</div>
      </div>
    </b-row>
    <b-row class="scout-keypoints-buttons">
      <button class="scout-keypoints-btn" @click="handleButtonClick()">
        <span>Get started for free</span>
      </button>
    </b-row>
  </Container>
</template>

<script>
import Container from '@/components/Container';

export default {
  name: 'ScoutKeypoints',
  components: {
    Container
  },
  props: {
    requestAccess: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      points: [
        {
          id: 'smart',
          img: require('@/assets/pages/scout/fast_forward.svg'),
          title: 'We work smarter, not harder',
          description:
            'Our recruiters, with firsthand startup experience, leverage specialized tools, streamlined processes, and targeted promotions—offering quality traditional recruiters can’t match.'
        },
        {
          id: 'exclusive',
          img: require('@/assets/pages/scout/multiple_stars.svg'),
          title: 'Exclusive access to 650k talents',
          description:
            'We own Europe’s largest database of startup-ready talent, tailored for rapid growth and dynamic environments. Behavioural insights help us nudge candidates at the perfect moment.'
        },
        {
          id: 'for',
          img: require('@/assets/pages/scout/startup.svg'),
          title: 'For startups... ONLY',
          description:
            'From pre-seed to post-IPO, we exclusively partner with startups and scale-ups, focusing solely on candidates seeking meaningful work.'
        },
        {
          id: 'cheaper',
          img: require('@/assets/pages/scout/mobile_payment.svg'),
          title: '90% cheaper than competitors',
          description:
            'Our pricing is designed to be a fraction of the cost compared to traditional methods of recruiting. €2,690 per hire—and only if you hire.'
        }
      ]
    };
  },
  methods: {
    handleButtonClick() {
      this.requestAccess();
    }
  },
  computed: {
    containerStyles() {
      return {
        'padding-top': `${2}rem`,
        'padding-bottom': `${4.5}rem`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.scout {
  a {
    color: #4440db;
  }
}

.scout-keypoints-title {
  margin-top: 1.5rem;
  width: 75%;
  @include media-breakpoint-down(md) {
    width: 100%;
  }
}

.scout-keypoints-points {
  // transform: scaleX(-1);
  // margin-top: 4rem;
  display: grid;
  margin: 2rem 0px 0px 0px;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 0.5rem;
  grid-row-gap: 3rem;
  @include media-breakpoint-down(md) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
  }
  @include media-breakpoint-down(xs) {
    grid-template-columns: repeat(1, 1fr);
    grid-template-columns: repeat(1, 1fr);
    grid-template-columns: repeat(1, 1fr);
    grid-template-columns: repeat(1, 1fr);
  }
}

.scout-keypoints-buttons {
  margin: 2rem 0 0 0;
  // margin-top: 3rem;
}

.scout-keypoints-point_wrapper {
  display: block;
}

.scout-keypoints-point_logo {
  height: 45px;
}

.scout-keypoints-point_title {
  font-weight: bold;
  // font-size: large;
  font-size: rem(20px);
  margin-top: 1.5rem;
}

.scout-keypoints-point_description {
  margin-top: 1rem;
  width: 80%;
}

.scout-keypoints-btn {
  background-color: #4440db;
  color: white;
  height: 4rem;
  width: 17.625rem;
  font-weight: bold;
}
</style>
